import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { PortalDashboardData } from '@/types/api';

/** Client-scoped summary for the portal home. */
export function usePortalDashboard() {
  return useQuery({
    queryKey: ['portal-dashboard'],
    queryFn: async (): Promise<PortalDashboardData> => {
      const { data } = await api.get<PortalDashboardData>('/v1/portal/dashboard');
      return data;
    },
  });
}
